import SubscriptionTimezoneCity from '../../enums/subscription/subscription_timezone/SubscriptionTimezoneCity';
import SubscriptionTimezoneContinent from '../../enums/subscription/subscription_timezone/SubscriptionTimezoneContinent';
import SubscriptionTimezoneCountry from '../../enums/subscription/subscription_timezone/SubscriptionTimezoneCountry';

export default class SubscriptionTimezone {
  private _city: SubscriptionTimezoneCity;
  private _continent: SubscriptionTimezoneContinent;
  private _country: SubscriptionTimezoneCountry;

  constructor(
    city: SubscriptionTimezoneCity,
    continent: SubscriptionTimezoneContinent,
    country: SubscriptionTimezoneCountry
  ) {
    this._city = city;
    this._continent = continent;
    this._country = country;
  }

  get city(): SubscriptionTimezoneCity {
    return this._city;
  }

  get continent(): SubscriptionTimezoneContinent {
    return this._continent;
  }

  get country(): SubscriptionTimezoneCountry {
    return this._country;
  }

  public copyWith({
    city,
    continent,
    country,
  }: {
    city?: SubscriptionTimezoneCity;
    continent?: SubscriptionTimezoneContinent;
    country?: SubscriptionTimezoneCountry;
  }): SubscriptionTimezone {
    return new SubscriptionTimezone(
      city ?? this._city,
      continent ?? this._continent,
      country ?? this._country
    );
  }

  static fromFirestoreMap(data: Record<string, any>): SubscriptionTimezone {
    return new SubscriptionTimezone(data.city, data.continent, data.country);
  }

  toMapPatch(): Record<string, any> {
    return {
      city: this._city,
      country: this._country,
      continent: this._continent,
    };
  }
}
